module.exports = __webpack_public_path__ + "resources/img/theme_well_rounded.gif";


//////////////////
// WEBPACK FOOTER
// ./src/resources/img/theme_well_rounded.gif
// module id = 1368
// module chunks = 0